export const PROSPECT_CREATE_CHANGE_TRACKING = {
  customer: {
    source: 'prospect_create.customer',
    id: 25001,
  },
  contact: {
    source: 'prospect_create.contact',
    id: 25002,
  },
} as const;
